import { render } from "./OwnerBatch.vue?vue&type=template&id=36d2a97b"
import script from "./OwnerBatch.vue?vue&type=script&lang=js"
export * from "./OwnerBatch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__